import { set } from "lodash";
import { FETCH_END } from "../../actions/fetchActions";
import {
  CREATE,
  GET_LIST,
  GET_MANY,
  GET_MANY_REFERENCE,
  GET_ONE,
  UPDATE,
} from "../../dataFetchActions";
import { getFetchedAt } from "../../util";

/**
 * Make the fetchedAt property non enumerable
 */
export const hideFetchedAt = (records) => {
  Object.defineProperty(records, "fetchedAt", {
    enumerable: false,
    configurable: false,
    writable: false,
  });
  return records;
};

/**
 * Add new records to the pool, and remove outdated ones.
 *
 * This is the equivalent of a stale-while-revalidate caching strategy:
 * The cached data is displayed before fetching, and stale data is removed
 * only once fresh data is fetched.
 */
export const addRecords = (newRecords = [], oldRecords) => {
  const newRecordsById = {};
  newRecords.forEach((record) => (newRecordsById[record.id] = record));

  const newFetchedAt = getFetchedAt(
    newRecords.map(({ id }) => id),
    oldRecords.fetchedAt
  );

  const records = { fetchedAt: newFetchedAt };
  Object.keys(newFetchedAt).forEach(
    (id) => (records[id] = newRecordsById[id] || oldRecords[id])
  );

  return hideFetchedAt(records);
};

const addSubRecord = (record, prevState, path) => {
  const newState = { ...prevState };
  // const subResource = get(newState, path, {});
  // subResource[record.id] = record;
  console.log("sub resource path:", `${path}.${record.id}`);
  set(newState, `${path}.${record.id}`, record);
  return newState;
};

const initialState = hideFetchedAt({ fetchedAt: {} });

const dataReducer = (previousState = initialState, { payload, meta }) => {
  if (!meta || !meta.fetchResponse || meta.fetchStatus !== FETCH_END) {
    return previousState;
  }

  switch (meta.fetchResponse) {
    case GET_LIST:
    case GET_MANY:
    case GET_MANY_REFERENCE:
      return addRecords(payload.data, previousState);
    case GET_ONE:
    case UPDATE:
    case CREATE:
      // TODO implement support for subresource?
      // return meta.subResource
      //   ? addSubRecord(
      //       payload.data,
      //       previousState,
      //       `${meta.id}.${meta.subResource}`
      //     )
      //   : addRecords([payload.data], previousState);
      return addRecords([payload.data], previousState);
    default:
      return previousState;
  }
};

export const getRecord = (state, id) => state[id];
export default dataReducer;
